import { useEffect, useState } from "react";

import { FullSite } from "../../../dtos/site";
import { SiteCommissioningSummary } from "../../../dtos/siteCommissioning";
import { AjaxResult } from "../../../enums/ajaxResult";
import { useApi } from "../../useApi";

export function useSiteCommissioningSummary(site: FullSite | undefined): SiteCommissioningSummary | undefined {
    const [commissioningSummary, setCommissioningSummary] = useState<SiteCommissioningSummary>();
    const { siteApi } = useApi();

    useEffect(() => {
        if (!site) {
            setCommissioningSummary(undefined);
            return;
        }
        siteApi.getCommissioning(site.id).then((r) => {
            if (r.result === AjaxResult.Success && r.data) {
                setCommissioningSummary(r.data);
            }
        });
    }, [site, siteApi]);

    return commissioningSummary;
}
